<template>
  <div id="app" :class="{'no-width-limit': noWidthLimit}">
    <transition name="fade"> 
      <alart-msg :display="alarmStatus.status" :count="alarmStatus.count" :closeBtn="alarmStatus.closeBtn" :styleType="alarmStatus.type" @alartStatus="$store.dispatch('setAlarmStatus', {status: false})">
        <span class="title" v-if="alarmStatus.title" slot="title">{{alarmStatus.title}}</span>
          <span class="description" v-if="alarmStatus.description" slot="description" v-html="alarmStatus.description">
          </span>
      </alart-msg>
    </transition>  
    <verified-alarm-modal></verified-alarm-modal>
    <router-view/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AlartMsg from '@/components/widge/AlartMsg.vue';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-tw';
import constant from '@/constant'
import verifiedAlarmModal from '@/components/widge/verifiedAlarmModal.vue';
import VueJwtDecode from 'vue-jwt-decode'

export default {
  name: 'App',
  data () {
    return {
      // alart: true
      noWidthLimit: false,
      isBussinessPage: false,
    }
  },
  created () {
    this.$store.dispatch('getCounty')
    this.$store.dispatch('getDistrict', 1)
    this.$store.dispatch('getRoad', 1)
    this.$store.dispatch('getDeviceSystem')
    // console.log(VueJwtDecode.decode('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOlsib2F1dGgyLXJlc291cmNlIl0sImV4cCI6MTYwNzU2NzQwMywidXNlcl9uYW1lIjoiMDk3ODc5NzcxMCIsImp0aSI6IjYwMzA4MGUzLWMzNTItNDI2Ni1hZmZmLWJhNjBlOWFjZTE4ZiIsImNsaWVudF9pZCI6ImZseXBpZ0NsaWVudCIsInNjb3BlIjpbImFwcCJdfQ.OtzOKo1-N4yOqiQHKqGl6yh58fZfnwHCEd4v3WOCYdA'))
    let refreshExpiredDate = localStorage.getItem('refreshToken')?VueJwtDecode.decode(localStorage.getItem('refreshToken')).exp:null
    this.isExpiredRefreshToken(refreshExpiredDate)
  },
  mounted () {
    this.device(this.$route.query);
  },
  watch: {
    $route:{
      handler: function (val) {
          // this.$store.dispatch('setAlarmStatus', {status: false})
          if(
            val.matched[0] && val.matched[0].path.includes('shareHouse') ||
            val.matched[0] && val.matched[0].path.includes('enterprise') ||
            val.matched[0] && val.matched[0].path.includes('landingPage') ||
            val.matched[0] && val.matched[0].path.includes('/landlord/login')  ||
            val.matched[0] && val.matched[0].path.includes('/bizPhoneSigned')  ||
            val.matched[0] && val.matched[0].path.includes('/mb/enterprise/')  ||
            val.matched[0] && val.matched[0].path === '' 
            ){
            this.noWidthLimit = true
          }else{
            this.noWidthLimit = false
          }
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    device: function (val) {
      // console.log(val.device)
      // console.log(val.shareHouseItem)
      console.log(val)
      let _self =this
      if(val.device){
        this.$analytics.logEvent('透過簡訊進入網站', { screen_name: '透過簡訊進入網站'})
        this.redirectUrl()
        // console.log('device')
      }else if(val.openLandlordApp){
        document.location = ''+constant.fetuzbookLandlordSchema+'://?houseCid='+val.id+'';
        setTimeout(function(){
          document.location.href = _self.appUrl.landlord
        }, 500);
      }else if(val.shareHouseItem){
        // this.$analytics.logEvent('透過預定房源進入網站', { screen_name: '透過預定房源進入網站'})
        // console.log(constant.fetuzbookTenantSchema)
        document.location = ''+constant.fetuzbookTenantSchema+'://?houseCid='+val.houseCid+'';
        setTimeout(function(){
          document.location.href = _self.appUrl.tenant
        }, 500);
      }else if(val.platform){
        this.$analytics.logEvent('平台:'+val.platform+'進入網站', { screen_name: '平台:'+val.platform+'進入網站'})
        let newQuery = JSON.parse(JSON.stringify(this.$route.query)) // 深拷贝
        delete newQuery.platform
        // 如果有引入 lodash, 可以写成: let newQuery = _.omit(this.$route.query, 'code')
        this.$router.replace({ query: newQuery })
      }
    },
    redirectUrl: function () {
      if(this.system != 'pc'){
          if(this.$route.query.type === 'tenant'){
            window.location.href = this.appUrl.tenant
          }else if(this.$route.query.type === 'landlord'){
            window.location.href = this.appUrl.landlord
          }else{
            window.location.href = this.appUrl.landlord
          }
      }else{
          this.$router.replace('/');
      }
    },
    isExpiredRefreshToken: function (date) {
      if(date){
        let now = new Date()
        let expireDate = new Date((date*1000)-constant.beforeRefreshTokenExpiredDate)
        console.log('refreshToken原始過期日', new Date(date*1000))
        console.log('refreshToken過期日', expireDate)
        console.log('現在日期', now)
        console.log('現在日期是否大於過期日', now > expireDate)
        if(now > expireDate){
          localStorage.removeItem('token')
          localStorage.removeItem('refreshToken')
          this.$router.push('/')
        }
      }
      
    }
  },
  computed: {
    ...mapGetters({
        system: 'GET_DEVICE_SYSTEM',
        appUrl: 'GET_APP_URL',
        alarmStatus: 'GET_ALARM'
    })
  },
  components: {
    AlartMsg,
    verifiedAlarmModal
  }
}
</script>
<style lang="scss">
@import "../static/css/global.scss";
@import "../static/css/default.scss";
@import "../static/css/landing.scss";
@import "../static/css/mbGlobal.scss";

body #app {
  width: 1440px;
  margin: 0 auto;
  overflow: hidden;
  .right-bg{
    position: absolute;
    width: 232px;
    height: 1072px;
    background: #f6f6f6;
    top: 80px;
    right: 0;
    z-index: 9;
  }
}

body #app.no-width-limit {
  width: 100%;
}
@media screen and (max-width: 1280px) {
  body #app {
    width: 1265px;
  }
  body #app.share {
    width: 100%;
  }
}

@media screen and (max-width: 500px) {
  body #app {
    width: 100%;
  }
  body #app.share {
    width: 100%;
  }
}
.alart-msg{
  .tick{
    width: 40px;
    height: 40px;
  }
  .content{
    .description a{
      display: flex;
      align-items: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue